"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
let Loader = class Loader extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.dots = ""; // Los puntos que se animan
        this.maxDots = 3; // Número máximo de puntos
        this.intervalId = null;
    }
    // Computed para mostrar los puntos
    get animatedDots() {
        return this.dots;
    }
    mounted() {
        this.startDotAnimation();
    }
    beforeUnmount() {
        this.stopDotAnimation();
    }
    startDotAnimation() {
        this.intervalId = window.setInterval(() => {
            this.dots = this.dots.length < this.maxDots ? this.dots + "." : "";
        }, 500); // Cambia los puntos cada 500ms
    }
    stopDotAnimation() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)()
], Loader.prototype, "provider", void 0);
Loader = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: { Loading: bmk_ui_framework_1.Loading }
    })
], Loader);
exports.default = Loader;
